<template>
  <div id="main-content">
    <div class="wrapper">
      <div class="table-agile-info">
        <jm-crumbs/>
        <div class="assignmentTaskList">
          <div>
            <el-button
              size="medium"
              type="primary"
              @click="dialogFormVisible = true">添加</el-button>
            <el-dialog
              width="30%"
              title="添加"
              :visible.sync="dialogFormVisible">
              <el-form :model="formData">
                <el-row>
                  <el-col :span="24">
                    <el-form-item>
                      <el-checkbox-group v-model="formData.checkedTasks">
                        <el-checkbox
                          v-for="item in tasks"
                          :label="item.id"
                          :key="item.id">
                          {{ item.fileName }}
                        </el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <div class="foot">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item>
                        <el-button
                          type="primary"
                          @click="addTask"
                          class="el-btn-save">确定
                        </el-button>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item>
                        <el-button
                          @click="dialogFormVisible = false"
                          class="el-btn-cancel">取消
                        </el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </el-dialog>
          </div>
          <div class="basic-title"><em>{{ countryName }}材料列表</em></div>
          材料：
          <el-select
            v-model="formData.material"
            placeholder="请选择"
            @change="selectChange"
            class="material">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
          <el-table
            class="tableList"
            border
            :data="tableData"
            style="width: 100%">
            <el-table-column
              width="1238"
              label="任务名称"
              prop="taskName"/>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="isdeleteTaskTpl(scope.row)">删除
                </el-button>
                <el-dialog
                  title="提示"
                  :visible.sync="deleteDialogVisible"
                  width="30%"
                  :before-close="handleClose">
                  <span>你确定删除“{{ deleteInfo }}”</span>
                  <span
                    slot="footer"
                    class="dialog-footer">
                    <el-button @click="deleteDialogVisible = false">取 消</el-button>
                    <el-button
                      type="primary"
                      @click="deleteFile">确 定</el-button>
                  </span>
                </el-dialog>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
    .assignmentTaskList .has-gutter th {
        background: #01142d;
    }

    .assignmentTaskList el-table {
        width: 1651px;
    }
</style>

<style scoped>

    .el-btn-save {
        background: #5daf34;
        border-color: #5daf34;
        color: #fff;
        float: right;
        margin-right: 10px;
    }

    .el-btn-save:hover {
        opacity: 0.8;
    }

    .el-btn-cancel {
        background: #ebb563;
        border-color: #ebb563;
        color: #fff;
        margin-left: 10px;
    }

    .el-btn-cancel:hover {
        opacity: 0.8;
    }

    .material {
        margin-bottom: 10px;
    }

    .tableList .el-table th {
        background-color: #01142d;
        height: 20px;
        line-height: 20px;
    }

</style>
<style>
</style>
<script>
import '@/assets/jsmind/style/jsmind.css';
import crumbs from '@/components/tool/crumbs.vue';

export default {
  data() {
    return {
      zidongId: '',
      zidongRid: [],
      taskId: '',
      deleteInfo: '',
      countryName: '',
      dialogFormVisible: false,
      deleteDialogVisible: false,
      tasks: {},
      options: [],
      formData: {
        material: '',
        checkedTasks: [],
      },
      tableData: [],
    };
  },
  components: {
    'jm-crumbs': crumbs,
  },
  methods: {
    selectChange: function () {
      this.getTaskList();
    },
    // 获取任务分配任务表格内容
    getTaskList() {
      let country = this.$route.params.country;
      this.zidongRid = [];
      this.$http._get({
        url: `/index/Task/getTaskList?country=${country}&typeId=${this.formData.material}` // 路由上的country
      }).then(({ data }) => {
        this.tableData = data;
        let i;
        for (i = 0; i < data.length; i++) {
          this.zidongRid.push(data[i].zidongRid);
        }
        console.log('lm', this.zidongRid);
        this.getTaskType();
      });
    },
    // 添加任务分配
    addTask: function () {
      console.log(this.formData);
      if (this.formData.checkedTasks.length === 0) {
        this.$message.error('请选择任务！');
      } else {
        this.$http
          ._post({
            url: `/index/Task/addTask?checked=${this.formData.checkedTasks}&typeId=${this.formData.material}`,
          })
          .then(() => {
            this.$message.success('添加成功！');
            this.dialogFormVisible = false;
            this.formData.checkedTasks = [];
            this.getTaskList();
          });
      }
    },
    // 获取可添加任务的内容（弹框）
    getTaskType() {
      let country = this.$route.params.country;
      this.$http._post({
        url: `/index/Task/getTaskType?country=${country}&zidongRid=${this.zidongRid}` // 路由
      }).then(({ data }) => {
        console.log(data);
        this.tasks = data;
      });
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done();
        })
        .catch(() => {
        });
    },
    handleDelete() {
      this.deleteDialogVisible = true;
    },
    // 材料下拉框
    getSelectOptions() {
      let country = this.$route.params.country;
      let materialType = '';
      switch (country) {
        case 'uk':
          materialType = '11';
          this.countryName = '英国';
          break;
        case 'aus':
          materialType = '21';
          this.countryName = '澳洲';
          break;
        case 'jp':
          materialType = '10';
          this.countryName = '日本';
          break;
        case 'usa':
          materialType = '31';
          this.countryName = '美国';
          break;
        case 'qiancheng_jp':
          materialType = '41';
          this.countryName = '前程日本';
          break;
        case 'qiancheng_lang':
          materialType = '-485';
          this.countryName = '前程语言';
          break;
        case 'all':
          materialType = '0';
          this.countryName = '全集';
          break;
        default:
          materialType = '';
      }
      this.$http._get({
        url: `/index/Task/getMaterialType?materialTypeId=${materialType}`
      }).then((data) => {
        this.options = data.data;
        this.formData.material = this.options[0].value;
        this.getTaskList();
      });
    },
    isdeleteTaskTpl(row) {
      console.log(row);
      this.deleteDialogVisible = true;
      this.deleteInfo = row.taskName;
      this.zidongId = row.zidongId;
      console.log(row);
    },
    // 根据zidongId删除表格中的文件数据
    deleteFile() {
      let zidongId = this.zidongId;
      this.$http._get({
        url: `/index/Task/deleteFile?zidongId=${zidongId}` // 路由上的country
      }).then((data) => {
        console.log(data);
        if (data.result === 0) {
          this.deleteDialogVisible = false;
          this.$message.success('删除成功！');
        } else {
          this.$message.error('删除失败！');
        }
        this.tableData = data;
        this.getTaskList();
      });
    }
  },
  mounted() {
    this.getSelectOptions();
  },
};
</script>
